export default "__VITE_ASSET__f9ad5a31__"